export const TABLE_COLUMNS = [
  {
    label: "UTM Source",
    value: "utm_source",
    removable: true,
    numeric: false,
  },
  {
    label: "UTM Medium",
    value: "utm_medium",
    removable: true,
    numeric: false,
  },
  {
    label: "UTM Campaign",
    value: "utm_campaign",
    removable: true,
    numeric: false,
  },
  {
    label: "UTM Content",
    value: "utm_content",
    removable: true,
    numeric: false,
  },
  {
    label: "UTM Term",
    value: "utm_term",
    removable: true,
    numeric: false,
  },
  {
    label: "Orders",
    value: "total_orders",
    removable: true,
    numeric: true,
  },
  {
    label: "Revenue",
    value: "total_revenue",
    removable: true,
    numeric: true,
  },
  {
    label: "Actions",
    value: "actions",
    removable: false,
    numeric: false,
  },
];

export const getStartingTableColumns = () => {
  return TABLE_COLUMNS.map(({ value }) => value);
};
